import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=6982be9c&"
import script from "./Simple.vue?vue&type=script&lang=ts&"
export * from "./Simple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6982be9c')) {
      api.createRecord('6982be9c', component.options)
    } else {
      api.reload('6982be9c', component.options)
    }
    module.hot.accept("./Simple.vue?vue&type=template&id=6982be9c&", function () {
      api.rerender('6982be9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layouts/Simple.vue"
export default component.exports